import { lazy } from "react";
import { RoutesLink } from "@/utility/RouteLinks";
import { permissionKeys } from "@/utility/helper";
import type { IPrivateRoutes } from "../types";

const Onboard = lazy(() => import("@/pages/HRMS/OnBoard/OnBoard"));
const Employees = lazy(() => import("@/pages/HRMS/Employee/Employees"));
const EmployeeDetail = lazy(() => import("@/pages/HRMS/Employee/EmployeeDetail"));
const CreateEmployee = lazy(() => import("@/pages/HRMS/Employee/CreateEmployee"));
const BulkImportEmployee = lazy(() => import("@/pages/HRMS/Employee/BulkImport/BulkImportEmployee"));
const OffboardingList = lazy(() => import("@/pages/HRMS/Offboarding/OffboardingList"));
const StartOffboarding = lazy(() => import("@/pages/HRMS/Offboarding/StartOffboarding"));
const ExitClearanceList = lazy(() => import("@/pages/HRMS/Offboarding/ExitClearance/ExitClearanceList"));
const ExitClearanceDetail = lazy(() => import("@/pages/HRMS/Offboarding/ExitClearance/ExitClearanceDetail"));

export const employeeRoutes: IPrivateRoutes[] = [
    {
        path: RoutesLink?.superAdminOnboard,
        route: <Onboard />,
    },
    {
        path: RoutesLink.superAdminEmplyoeeOnboard,
        route: <Employees />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.employeeDetail}/:id`,
        route: <EmployeeDetail />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: RoutesLink.createEmployee,
        route: <CreateEmployee />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.editEmployee}/:id`,
        route: <CreateEmployee />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: RoutesLink.bulkImportEmployee,
        route: <BulkImportEmployee />,
        accessKey: permissionKeys.hrmSetting,
    },
    // Offboarding
    {
        path: RoutesLink.offboardingList,
        route: <OffboardingList />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: RoutesLink.startOffboarding,
        route: <StartOffboarding />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.startOffboarding}/:id`,
        route: <StartOffboarding />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.startOffboarding}/:id/:offboardingId`,
        route: <StartOffboarding />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.editOffboarding}/:id`,
        route: <StartOffboarding />,
        accessKey: permissionKeys.hrmSetting,
    },
    {
        path: `${RoutesLink.editOffboarding}/:id/:offboardingId`,
        route: <StartOffboarding />,
        accessKey: permissionKeys.hrmSetting,
    },
    // Exit Clearance
    {
        path: RoutesLink.exitClearanceList,
        route: <ExitClearanceList />,
        accessKey: permissionKeys.exitClearance,
    },
    {
        path: `${RoutesLink.viewExitClearance}/:id`,
        route: <ExitClearanceDetail />,
        accessKey: permissionKeys.exitClearance,
    },
];
